import React from "react";
import { cn } from "@/lib/utils";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "outlinePrimary" | "outlineSecondary" | "ghost" | "outlineDark" | "dark" | "accent" | "outlineAccent";
  size?: "sm" | "md" | "lg";
  children: React.ReactNode;
  asChild?: boolean;
  disclaimer?: string;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = "primary", size = "md", asChild = false, children, disclaimer, ...props }, ref) => {
    const variantClasses = {
      primary: "btn-primary",
      secondary: "btn-secondary",
      outlinePrimary: "btn-outline-primary",
      outlineSecondary: "btn-outline-secondary",
      ghost: "btn-ghost",
      outlineDark: "btn-outline-dark",
      dark: "btn-dark",
      accent: "btn-accent",
      outlineAccent: "btn-outline-accent",
    };

    const sizeClasses = {
      sm: "btn-sm",
      md: "btn-md",
      lg: "btn-lg",
    };

    if (asChild) {
      const {
        disabled,
        form,
        formAction,
        formEncType,
        formMethod,
        formNoValidate,
        formTarget,
        name,
        type,
        value,
        autoFocus,
        ...divProps
      } = props;
      return (
        <div
          className={cn(variantClasses[variant], sizeClasses[size], className)}
          {...(divProps as React.HTMLAttributes<HTMLDivElement>)}
        >
          {children}
          {disclaimer && <span className="text-xs text-gray-500">{disclaimer}</span>}
        </div>
      );
    }

    return (
      <button
        type="button"
        className={cn(variantClasses[variant], sizeClasses[size], className)}
        ref={ref}
        {...props}
      >
        {children}
      </button>
    );
  }
);

Button.displayName = "Button";

export { Button };
